// Generated by purs version 0.15.0
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Map_Serialized from "../Data.Map.Serialized/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
import * as Restaumatic_Menu_V2_Types_ParameterChoiceId from "../Restaumatic.Menu.V2.Types.ParameterChoiceId/index.js";
import * as Restaumatic_Menu_V2_Types_ParameterId from "../Restaumatic.Menu.V2.Types.ParameterId/index.js";
import * as Unscramble from "../Unscramble/index.js";
var Parametric = function (x) {
    return x;
};
var udecodeParametric = function (dictDecode) {
    return Unscramble.decodeRecord1()(Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "values";
        }
    })(Data_Map_Serialized.udecodeMap(Data_Map_Serialized.ordMap(Restaumatic_Menu_V2_Types_ParameterId.ordParameterId)(Restaumatic_Menu_V2_Types_ParameterChoiceId.ordParameterChoiceId))(Data_Map_Serialized.fromJSONKeyMap(Restaumatic_Menu_V2_Types_ParameterId.ordParameterId)(Restaumatic_Menu_V2_Types_ParameterId.ufromJSONKeyParameterId)(Restaumatic_Menu_V2_Types_ParameterChoiceId.unscrambleDecodeParameterChoiceId))(dictDecode))(Unscramble.decodeRecordNil));
};
var showParametric = function (dictShow) {
    return Data_Show.showRecord()()(Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "values";
        }
    })(Data_Show.showRecordFieldsNil)(Data_Map_Serialized.showMap(Data_Map_Serialized.showMap(Restaumatic_Menu_V2_Types_ParameterId.showParameterId)(Restaumatic_Menu_V2_Types_ParameterChoiceId.showParameterChoiceId))(dictShow)));
};
var newtypeParametric = {
    Coercible0: function () {
        return undefined;
    }
};
var eqParametric = function (dictEq) {
    return Data_Eq.eqRec()(Data_Eq.eqRowCons(Data_Eq.eqRowNil)()({
        reflectSymbol: function () {
            return "values";
        }
    })(Data_Map_Serialized.eqMap(Data_Map_Serialized.eqMap(Restaumatic_Menu_V2_Types_ParameterId.eqParameterId)(Restaumatic_Menu_V2_Types_ParameterChoiceId.eqParameterChoiceId))(dictEq)));
};
var encodeParametric = function (dictEncode) {
    return function (dictGenericEncodeArgs) {
        return Foreign_Generic_Class.recordEncode()(Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordNil)({
            reflectSymbol: function () {
                return "values";
            }
        })(Foreign_Generic_Class.encodeWithOptionsOther(Data_Map_Serialized.encodeMap(Data_Map_Serialized.asJSONKeyMap(Restaumatic_Menu_V2_Types_ParameterId.ordParameterId)(Restaumatic_Menu_V2_Types_ParameterId.asJSONKeyParameterId)(Data_Map_Serialized.encodeMap(Restaumatic_Menu_V2_Types_ParameterId.asJSONKeyParameterId)(Restaumatic_Menu_V2_Types_ParameterChoiceId.encodeParameterChoiceId)(Foreign_Generic_Class.genericEncodeArgsArgument(Foreign_Generic_Class.encodeWithOptionsOther(Restaumatic_Menu_V2_Types_ParameterChoiceId.encodeParameterChoiceId))))(Data_Map_Serialized.decodeMap(Restaumatic_Menu_V2_Types_ParameterId.ordParameterId)(Restaumatic_Menu_V2_Types_ParameterId.asJSONKeyParameterId)(Restaumatic_Menu_V2_Types_ParameterChoiceId.decodeParameterChoiceId)(Foreign_Generic_Class.genericDecodeArgsArgument(Foreign_Generic_Class.decodeWithOptionsOther(Restaumatic_Menu_V2_Types_ParameterChoiceId.decodeParameterChoiceId)))))(dictEncode)(dictGenericEncodeArgs))));
    };
};
var decodeParametric = function (dictDecode) {
    return function (dictGenericDecodeArgs) {
        return Foreign_Generic_Class.recordDecode()(Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordNil)({
            reflectSymbol: function () {
                return "values";
            }
        })(Foreign_Generic_Class.decodeWithOptionsOther(Data_Map_Serialized.decodeMap(Data_Map_Serialized.ordMap(Restaumatic_Menu_V2_Types_ParameterId.ordParameterId)(Restaumatic_Menu_V2_Types_ParameterChoiceId.ordParameterChoiceId))(Data_Map_Serialized.asJSONKeyMap(Restaumatic_Menu_V2_Types_ParameterId.ordParameterId)(Restaumatic_Menu_V2_Types_ParameterId.asJSONKeyParameterId)(Data_Map_Serialized.encodeMap(Restaumatic_Menu_V2_Types_ParameterId.asJSONKeyParameterId)(Restaumatic_Menu_V2_Types_ParameterChoiceId.encodeParameterChoiceId)(Foreign_Generic_Class.genericEncodeArgsArgument(Foreign_Generic_Class.encodeWithOptionsOther(Restaumatic_Menu_V2_Types_ParameterChoiceId.encodeParameterChoiceId))))(Data_Map_Serialized.decodeMap(Restaumatic_Menu_V2_Types_ParameterId.ordParameterId)(Restaumatic_Menu_V2_Types_ParameterId.asJSONKeyParameterId)(Restaumatic_Menu_V2_Types_ParameterChoiceId.decodeParameterChoiceId)(Foreign_Generic_Class.genericDecodeArgsArgument(Foreign_Generic_Class.decodeWithOptionsOther(Restaumatic_Menu_V2_Types_ParameterChoiceId.decodeParameterChoiceId)))))(dictDecode)(dictGenericDecodeArgs)))());
    };
};
export {
    Parametric,
    newtypeParametric,
    showParametric,
    eqParametric,
    decodeParametric,
    udecodeParametric,
    encodeParametric
};
//# sourceMappingURL=index.js.map
